<template>
  <div>
    <v-btn @click="onClick" dark color="primary">
      <v-icon>add</v-icon>
      新規案件
    </v-btn>
    <IOModalEdit
      v-if="insertionOrder"
      v-model="modalVisible"
      :insertion-order="insertionOrder"
      :advertiser="advertiser"
      :sales-account-list="salesAccountList"
      :loading="loading"
      @success="onSuccess"
      @cancel="onCancel"
      can-edit
    />
  </div>
</template>

<script>
import IOModalEdit from '../IOModalEdit'
import { InsertionOrdersModel } from '@/models/InsertionOrders'

export default {
  name: 'AddButton',
  components: { IOModalEdit },
  props: {
    advertiser: {
      type: Object,
      required: true,
    },
    loading: {
      type: Object,
      default: () => {},
    },
    salesAccountList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalVisible: false,
      insertionOrder: null,
      isValid: false,
    }
  },
  methods: {
    onClick() {
      this.insertionOrder = new InsertionOrdersModel({
        advertiserId: this.advertiser.id,
      })
      this.modalVisible = true
    },
    async onSuccess(savedInsertionOrder) {
      this.insertionOrder = null
      this.modalVisible = false
      const result = await this.$confirm('', {
        cancelText: '閉じる',
        okText: 'キャンペーン作成へ',
        body:
          '広告配信をする場合、キャンペーンの作成および予算設定が必要です。',
      })
      if (!result) {
        return
      }
      this.$emit('openCampaignModal', savedInsertionOrder)
    },
    onCancel() {
      this.insertionOrder = null
      this.modalVisible = false
    },
  },
}
</script>
